// extracted by mini-css-extract-plugin
module.exports = {"textContent":"searchView_textContent__14i4d","spinnerContainer":"searchView_spinnerContainer__1LOUZ"};